export default {
  name: 'page-header',
  computed: {
    activeApp() {
      return this.$store.getters['app/activeApp'];
    },
    pageHeader() {
      if (this.$route && this.$route.name === 'account-courses') {
        return 'Super Courses';
      }
      if (this.activeApp && this.activeApp.appName === 'HOME') {
        return `Welcome to the Heffron IQ Portal, ${this.user}`;
      }
      return this.activeApp ? this.activeApp.display : '';
    },
    user() {
      return this.$store.getters['auth/getUserGivenName'];
    },
  },
};
